// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#more{font-family:'Poppins', sans-serif;font-style:normal;font-weight:500;font-size:12px;line-height:18px;letter-spacing:0.2px;text-transform:uppercase;color:#343538;white-space:nowrap;transition:0.3s ease;display:flex;align-items:center;gap:6px;cursor:pointer}#more:hover{color:#7b22ec}@media screen and (min-width: 2080px){#more{font-size:14px}}.tags-nav__item-icon{width:10px;height:5px}\n", ""]);
// Exports
module.exports = exports;
